import { axios } from './config';

// 企业信息
export function getentErpriseData(params) {
  return axios.get('/largeScreen/companyBaseInfo', params, false)
}

// 隐患整改情况
export function getentAreaInfoData(params) {
  return axios.get('/largeScreen/dangerGovernInfo', params, false)
}

//  巡检任务完成情况
export function getDangerTaskInfoData(params) {
  return axios.get('/largeScreen/dangerTaskInfo', params, false)
}

// 4、风险数量比例统计
export function getProcessRiskPointData(params) {
  return axios.get('/largeScreen/processRiskPointInfo', params, false)
}
// 5、作业票数据信息
export function getWorkPermitInfoData(params) {
  return axios.get('/largeScreen/workPermitInfo', params, false)
}
// 5、风险点/风险比较图
export function getRiskListData(params) {
  return axios.get('/largeScreen/riskPointsInfo', params, false)
}